import mixitup from 'mixitup';
import mixitupMultifilter from '../../../General/Mixitup/multifilter.js';

mixitup.use(mixitupMultifilter);

const mixitupContainer = document.querySelector('.room-overview');

if (mixitupContainer) {
    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: 'all',
        },
        selectors: {
            target: '.room-teaser',
        },
        animation: {
            easing: 'ease-in-out',
        },
        multifilter: {
            enable: true,
        },
    });
}

const onMobile = window.matchMedia('(max-width: 768px)').matches;

// Click event on filter buttons and hides the filter selection box
const buttons = document.querySelectorAll('.filter-select-box.-js-accordion__target .filter-select__button');
const filterSection = document.querySelectorAll('.filter-section.-js-accordion');

if (buttons) {
    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            filterSection.forEach((section) => {
                section.classList.remove('-js-accordion--open');
            });
            const filterSelectBox = button.closest('.filter-select-box.-js-accordion__target');
            filterSelectBox.style.maxHeight = '0';
        });
    });
}

const teaserHearts = document.querySelectorAll('.room-teaser__heart');
const boxes = document.querySelectorAll('.room-compare');
const roomOne = document.querySelector('.room-compare--one');
const roomTwo = document.querySelector('.room-compare--two');
const roomThree = document.querySelector('.room-compare--three');
const roomOverview = document.querySelector('.room-overview');
const teaserCloseBtns = document.querySelectorAll('.room-compare .room-compare__icon-delete');
const compareBtn = document.querySelector('.compare-button');

teaserCloseBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
        const currentComparison = window.localStorage.getItem('comparison');
        const roomId = btn.parentElement.dataset.id;

        let comparisonArray = JSON.parse(currentComparison);

        if (!Array.isArray(comparisonArray)) {
            comparisonArray = [];
        }

        comparisonArray = comparisonArray.filter((id) => id !== roomId);
        window.localStorage.setItem('comparison', JSON.stringify(comparisonArray));
        const teaserHeart = document.querySelector(`.room-teaser__heart[data-id="${roomId}"]`);
        teaserHeart.classList.remove('room-teaser__heart--active');
        resetCompareBoxes(boxes);
        fillCompareBoxes(comparisonArray);
    });
});

if (teaserHearts) {
    // on reaload
    if (roomOverview) {
        const currentComparison = window.localStorage.getItem('comparison');

        let comparisonArray = JSON.parse(currentComparison);

        if (!Array.isArray(comparisonArray)) {
            comparisonArray = [];
        }

        if (comparisonArray.length === 0) {
            roomOne.classList.remove('room-compare--active');
            roomTwo.classList.remove('room-compare--active');
            roomThree.classList.remove('room-compare--active');

            roomOne.querySelector('.icon--room-compare ').classList.remove('icon--hidden');
            roomTwo.querySelector('.icon--room-compare ').classList.remove('icon--hidden');
            roomThree.querySelector('.icon--room-compare ').classList.remove('icon--hidden');
        }

        fillCompareBoxes(comparisonArray);

        comparisonArray.forEach((id) => {
            const teaserHeart = document.querySelector(`.room-teaser__heart[data-id="${id}"]`);

            teaserHeart.classList.add('room-teaser__heart--active');
        });
    }

    teaserHearts.forEach((teaserHeart) => {
        teaserHeart.addEventListener('click', () => {
            resetCompareBoxes(boxes);

            const currentComparison = window.localStorage.getItem('comparison');

            let comparisonArray = JSON.parse(currentComparison);

            if (!Array.isArray(comparisonArray)) {
                comparisonArray = [];
            }

            if (teaserHeart.classList.contains('room-teaser__heart--active')) {
                comparisonArray = comparisonArray.filter((id) => id !== teaserHeart.dataset.id);
                window.localStorage.setItem('comparison', JSON.stringify(comparisonArray));
                teaserHeart.classList.remove('room-teaser__heart--active');
            } else {
                teaserHeart.classList.add('room-teaser__heart--active');
                if (!currentComparison || currentComparison === '[]' || currentComparison === '') {
                    comparisonArray.push(teaserHeart.dataset.id);
                    window.localStorage.setItem('comparison', JSON.stringify(comparisonArray));
                } else {
                    if (comparisonArray.length === 3) {
                        comparisonArray.shift();
                    }
                    comparisonArray.push(teaserHeart.dataset.id);
                    window.localStorage.setItem('comparison', JSON.stringify(comparisonArray));
                }
            }

            fillCompareBoxes(comparisonArray);
        });
    });
}

function resetCompareBoxes(boxes) {
    boxes.forEach((box) => {
        box.classList.remove('room-compare--active');
        box.querySelector('.icon--room-compare').classList.remove('icon--hidden');
        box.querySelector('img').src = '';
        box.dataset.id = '';
    });

    compareBtn.classList.remove('compare-button--active');
}

function fillCompareBoxes(comparisonArray) {
    comparisonArray.forEach((id, index) => {
        const teaserHeart = document.querySelector(`.room-teaser__heart[data-id="${id}"]`);

        if (index === 0) {
            roomOne.classList.add('room-compare--active');
            roomOne.querySelector('.icon--room-compare ').classList.add('icon--hidden');
            const imageSrc = teaserHeart.parentElement.querySelector('.image img').src;
            roomOne.querySelector('img').src = imageSrc;
            teaserHeart.classList.add('room-teaser__heart--active');
            roomOne.dataset.id = teaserHeart.dataset.id;
        } else if (index === 1) {
            roomTwo.classList.add('room-compare--active');
            roomTwo.querySelector('.icon--room-compare ').classList.add('icon--hidden');
            const imageSrc = teaserHeart.parentElement.querySelector('.image img').src;
            roomTwo.querySelector('img').src = imageSrc;
            teaserHeart.classList.add('room-teaser__heart--active');
            roomTwo.dataset.id = teaserHeart.dataset.id;
        } else if (index === 2) {
            roomThree.classList.add('room-compare--active');
            roomThree.querySelector('.icon--room-compare ').classList.add('icon--hidden');
            const imageSrc = teaserHeart.parentElement.querySelector('.image img').src;
            roomThree.querySelector('img').src = imageSrc;
            teaserHeart.classList.add('room-teaser__heart--active');
            roomThree.dataset.id = teaserHeart.dataset.id;
        }
    });

    if (comparisonArray.length > 1) {
        compareBtn.classList.add('compare-button--active');
    }
}
